var map = {
	"./azure.svg": 6895,
	"./c-sharp.svg": 5558,
	"./fourier.webp": 2186,
	"./fourier_thumbnail.webp": 7261,
	"./hanoi.gif": 9108,
	"./hanoi.webp": 1169,
	"./hanoi_thumbnail.webp": 6338,
	"./matlab.svg": 9557,
	"./menu-open.svg": 5968,
	"./profile-photo-600.webp": 4605,
	"./salsa.gif": 9265,
	"./salsa_thumbnail.webp": 7685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7918;